import axios from "axios";

const api = axios.create({
     baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

// 1. Request Interceptor
api.interceptors.request.use(
    async (config) => {
        const token = localStorage.getItem("jwtToken");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// 2. Response Interceptor
api.interceptors.response.use(
    (response) => {
        // If the request succeeds
        return response;
    },
    (error) => {
        // If the request fails...
        if (error.response) {
            const { status } = error.response;

            // Check if the error is 403 (Forbidden) or 401 (Unauthorized)
            if (status === 403 || status === 401) {
                // TOKEN IS BAD/EXPIRED -> FORCE LOGOUT
                localStorage.removeItem("jwtToken");

                // Force a hard redirect to login page
                window.location.href = "/login";
            }
        }

        // Pass the error along (so your specific page can stop loading spinners, etc.)
        return Promise.reject(error);
    }
);

export { api };
